import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

import { UserService } from '../../shared/services/user.service';

export const eOrderUserGuard: CanActivateFn = () => {
	const userService = inject(UserService);

	return userService.user.hasService('EORDR');
};
